export default "__VITE_ASSET__MDd_t$QX__"